export default "__VITE_ASSET__DNJlV$km__"